import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHZonaGet = async (credentials, data) => {
  const body = {
    service: "RNHZonaGet",
    params: {
      rnhZonaId: data?.rnhZonaId || null,
    },
  };

  return respuestaDe(await axiosPost(body, credentials));
};
